import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { TripsTableComponent } from '@components';
import { Trip } from '@models';
import { TripService, UtilService } from '@services';

@Component({
  standalone: true,
  imports: [TripsTableComponent],
  templateUrl: './trips.page.html',
  styleUrl: './trips.page.scss',
})
export class TripsPage implements OnInit {
  columns: string[] = [
    'driver',
    'vehicle',
    'totalWeight',
    'totalVolume',
    'plannedAt',
    'completedAt',
    'status',
  ];

  columnLabels: Record<string, string> = {
    driver: 'Driver',
    vehicle: 'Vehicle',
    totalWeight: 'Total Weight (kg)',
    totalVolume: 'Total Volume (cm³)',
    plannedAt: 'Planned At',
    completedAt: 'Completed At',
    status: 'Status',
  };

  public loading: boolean = true;
  public pageSize: number = 20;
  public pageIndex: number = 0;
  public totalTrips: number = 0;
  public trips: Trip[] = [];

  constructor(
    private tripService: TripService,
    public utils: UtilService
  ) {}

  public ngOnInit(): void {
    this.fetchTripsPage();
  }

  public onPageChange(e: PageEvent): void {
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.fetchTripsPage();
  }

  private async fetchTripsPage(): Promise<void> {
    this.loading = true;

    try {
      const response = await this.tripService.getPage({
        offset: this.pageIndex * this.pageSize,
        limit: this.pageSize,
      });
      this.totalTrips = response.count;
      this.trips = response.data;
    } catch (error) {
      console.error('Error occurred during fetching trips page', {
        cause: error,
      });
    }

    this.loading = false;
  }
}
